






















































import Vue from 'vue';
import * as api from '@/api';
import { ElForm } from 'element-ui/types/form';

export default Vue.extend({
      data() {
            const self: any = this;
            const validatePhone = (rule, value, callback) => {
                if (!value.match(/^1[3-9]\d{9}$/)) {
                    callback('手机号格式错误');
                }
                callback();
            };
            const validatePass = (rule, value, callback) => {
                if (!self.setForm.password) {
                    callback('请输入密码');
                } else if (self.setForm.confirmedPassword !== '') {
                    self.$refs.setForm.validateField('confirmedPassword');
                }
                callback();
            };
            const validatePass2 = (rule, value, callback) => {
                if (!self.setForm.confirmedPassword) {
                    callback('请输入确认密码');
                } else if (self.setForm.confirmedPassword !== self.setForm.password) {
                    callback(new Error('两次输入密码不一致'));
                } else {
                    callback();
                }
            };
            const validateCode = (rule, value, callback) => {
                if (!value) {
                    callback('请输入验证码');
                } else if (!value.match(/^[0-9]{6}$/)) {
                    callback('验证码格式错误');
                }
                callback();
            };
            return {
                errorMsg: '',
                successPasswrod: false,
                next: false,
                tabIndex: 0,
                findForm: {
                    captcha: '',
                    phoneNumber: '',
                },
                findRules: {
                    phoneNumber: [
                        { required: true, message: '请输入手机号', trigger: 'blur' },
                        { validator: validatePhone, trigger: 'blur' },
                    ],
                    captcha: [
                        { validator: validateCode, trigger: 'blur' },
                    ],
                },
                setForm: {
                    password: '',
                    confirmedPassword: '',
                },
                setRules: {
                    password: [
                        { validator: validatePass, trigger: 'blur' },
                        { min: 6, message: '密码至少为6个字符', trigger: 'blur' },
                    ],
                    confirmedPassword: [
                        { validator: validatePass2, trigger: 'blur' },
                        { min: 6, message: '密码至少为6个字符', trigger: 'blur' },
                    ],
                },
                smsCountDown: 0,
            };
    },
    methods: {
      // 找回密码
      verify() {
        (this.$refs.findForm as ElForm).validate(async (valid) => {
        if (valid) {
          const res = await api.putFindPassword(this.findForm);
          this.errorMsg = '';
          if (!api.error(res)) {
            this.next = true;
          } else {
            this.$nextTick(() => { this.errorMsg = res.error.message; });
          }
        } else {
          console.log('error submit!!');
          return false;
        }
        return true;
        });
      },
      // 重置密码
      onSubmit() {
        (this.$refs.setForm as ElForm).validate(async (valid) => {
          if (valid) {
            const form = {
              phoneNumber: this.findForm.phoneNumber,
              captcha: this.findForm.captcha,
              newPassword: this.setForm.confirmedPassword,
            };
            const res = await api.putResetPassword(form);
            if (!api.error(res)) {
              this.successPasswrod = true;
            } else {
              this.$message.error(res.error.message);
            }
          } else {
            console.log('error submit!!');
            return false;
          }
          return true;
          });
      },
      sendVerificationCode() {
            // todo: 连续点多次，会触发多条短信吗？
            (this.$refs.findForm as ElForm).validateField('phoneNumber', async (err) => {
                if (err) return;
                const res = await api.sendSMSCaptcha({
                    phoneNumber: this.findForm.phoneNumber,
                });
                if (!api.error(res)) {
                    this.smsCountDown = 60;
                    const timer = setInterval(() => {
                        this.smsCountDown -= 1;
                        if (this.smsCountDown === 0) {
                            clearInterval(timer);
                        }
                    }, 1000);
                } else {
                    this.$message({
                        type: 'error',
                        message: res.error.message,
                    });
                }
            });
      },
    },
});

